import React from 'react';
import { Link } from 'react-router-dom';
import { isD2RAdminEmail } from '../../constants/d2rAdminEmails';

const DesktopHeader = ({ user }) => {
  const userType = (user?.userType || user?.role || '').toString().toLowerCase();
  const isStudent = userType === 'student';
  const canCreateProjects = userType === 'employer';
  const firstName = user?.name?.split(',')[1]?.trim().split(' ')[0] || 'You';
  const email = (user?.Email || user?.email || user?.preferred_username || '').toString().trim().toLowerCase();
  const isAdmin = isD2RAdminEmail(email);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <header className="main-header site-header--alt site-header--department show-for-medium">
      {/* 🔺 Top utility nav */}
      <nav className="utility-nav utility-nav--department">
        <div className="utility-nav__container">
          <div className="site-header__back">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <a href="https://research.tamu.edu/" className="site-header__parent-link">
                <svg style={{ marginRight: '4px' }}>
                  <use href="#aux_arrow-up-right" />
                </svg>
                DIVISION OF RESEARCH
              </a>
              <span>|</span>
              <a href="https://tamids.tamu.edu/" className="site-header__department-link">
                TEXAS A&M Institute of Data Science
              </a>
            </div>
          </div>

          {/* 🔻 "For You" Buttons */}
          <div
            className="utility-nav__right"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <a
              href="#"
              onClick={handleLogout}
              className="btn btn--primary-dark btn--sm"
              style={{ fontSize: '15px', padding: '3px 7px' }}
            >
              Logout
            </a>
          </div>
        </div>
      </nav>

      {/* 🔻 Identity branding */}
      <div className="site-header__identity">
        <div className="identity">
          <a href="#" onClick={e => e.preventDefault()}>
            <div className="identity__logo">
              <img src="https://aux.tamu.edu/logos/boxTAM.svg" alt="Texas A&M University logo" />
            </div>
            <div className="identity__wordmark">
              <span className="wordmark__small">Institute of Data Science</span>
              <span className="wordmark__large">Data2Reality</span>
            </div>
          </a>
        </div>
      </div>

      {/* 🔻 Navigation Menu */}
      <nav className="site-header__nav">
        <ol className="menu">
          <li className="menu-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="menu-item">
            <Link to="/projects">Projects</Link>
          </li>
          {isStudent && (
            <li className="menu-item">
              <Link to="/profile">Profile</Link>
            </li>
          )}
          {canCreateProjects && (
            <li className="menu-item">
              <Link to="/project-form">Add New Project</Link>
            </li>
          )}
          {isAdmin && (
            <li className="menu-item">
              <Link to="/admin/project-proposals">Admin</Link>
            </li>
          )}
        </ol>
      </nav>
    </header>
  );
};

export default DesktopHeader;
